// JQuery init
$(document).ready(function () {
	// init foundarion
	$(document).foundation(); // 確保 Foundation 已宣告

	var integritySwiper = new Swiper('#integrity-swiper .swiper-container', {
		slidesPerView: 1,
		spaceBetween: 10,
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 40,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 50,
			},
			1440: {
				slidesPerView: 3,
				spaceBetween: 50,
			},
		},
		on: {
			init: function (params) {
				// swiper初始化時，才建立 Equalizer，避免 swiper 尚未建立時，造成 Equalizer 計算高度錯誤。
				var equalizer = new Foundation.Equalizer($('#integrity-swiper .swiper-wrapper'));
			},
		},
		navigation: {
			nextEl: '#integrity-swiper .swiper-button-next',
			prevEl: '#integrity-swiper .swiper-button-prev',
		},
		pagination: {
			el: '#integrity-swiper .swiper-pagination',
			clickable: true,
		},
		watchOverflow: true,
	});
});
